// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import enrolEntity from './entities/enrol.json';
import enrolMenu from '../pages/enrol/menu.json';
import enrolFullForm from '../pages/enrol/forms/full.json';
import enrolContextForm from '../pages/enrol/forms/context.json';
import enrolMiniForm from '../pages/enrol/forms/mini.json';
import enrolLookupForm from '../pages/enrol/forms/lookup.json';
import enrolTableView from '../pages/enrol/views/table.json';
import enrolStagesView from '../pages/enrol/views/stages.json';
import enrolCardsView from '../pages/enrol/views/cards.json';
import enrolInlineView from '../pages/enrol/views/inline.json';
import enrolBacklogView from '../pages/enrol/views/backlog.json';
import enrolSplitView from '../pages/enrol/views/split.json';
import enrolCalendarView from '../pages/enrol/views/calendar.json';
import enrolDashboardView from '../pages/enrol/views/dashboard.json';

/** Тип запису «Запис на навчання» зі сторінками пакета: меню, форми та подання з pages/enrol/. */
export const enrolDefinition: IRecordTypeDefinition = {
  ...enrolEntity,
  views: assembleViewSet({
      table: enrolTableView,
      stages: enrolStagesView,
      cards: enrolCardsView,
      inline: enrolInlineView,
      backlog: enrolBacklogView,
      split: enrolSplitView,
      calendar: enrolCalendarView,
      dashboard: enrolDashboardView,
  }),
  form: enrolFullForm,
  forms: { full: enrolFullForm, context: enrolContextForm, mini: enrolMiniForm, lookup: enrolLookupForm },
  menu: enrolMenu,
} as IRecordTypeDefinition;
